import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, NotepadTypeNames } from 'ep-bt-controls';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FieldAgentClient, NotepadTypeApplyTo } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { GetCustomerNotepadItemsRequest, PagingParameters, SortParameters, SortParametersDirection, GetCustomerNotepadItemsRequestConsumer } from 'ep-bt-field-agent-proxy';
import { IEpBtFaCardModel } from '../../models/epbt-fa-card.model';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-notepad-grid',
  templateUrl: './epbt-fa-notepad-grid.component.html',
  styleUrls: ['./epbt-fa-notepad-grid.component.scss']
})
export class EpbtFaNotepadGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  @Input() customerId: number;

  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
    // this.filterService.notepadSubject = this._searchString;
    // console.log(this._searchString + "search string");
  }

  get searchString(): string { return this._searchString; }

  @ViewChild('emailTemplate', {static: true}) emailTemplate: TemplateRef<any>;
  @ViewChild('dateTemplate', {static: true}) dateTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', {static: true}) statusTemplate: TemplateRef<any>;
  @ViewChild('customerTemplate', {static: true}) customerTemplate: TemplateRef<any>;
  @ViewChild('createdDateTemplate', {static: true}) createdDateTemplate: TemplateRef<any>;

  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public card: Array<IEpBtFaCardModel>;


  @Output() loadingChange = new EventEmitter<boolean>();
  notePadCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  // @Input() loadAll: boolean;
  // @Input() loading: boolean;
  // @Output() loadingChange = new EventEmitter<boolean>();
  // callApi: boolean = true;
  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private filterService: EpbtFaFilterService,
    private router: Router, private faService: EpbtFieldAgentService, public customerService: EpbtFaCustomerService,
    private config: BistrackConfig,
    private sortService: EpbtFaSortService) { }
  result: any;

  // testing

  webTrackUser: any;
  customerNotepadItemsRequest: GetCustomerNotepadItemsRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;
  notepads: any = [];
  // length: number = 0;


  ngOnInit() {
    // console.log("epbt-fa-notepad-grid");
    // console.log(this.customerId);
    // var bistrackSettings = this.faService.getBisTrackSetting();
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });

    // this.pageSize= bistrackSettings.searchPageSize;
    this.card = [
      // { field: "subject", isTitle: true, displayName: "Customer", icon: "" },
      { field: 'subject', isTitle: true, displayName: 'Subject', icon: '' },
      //   { field: "customerCode", isTitle: true, displayName: "", icon: "" },
      // { field: "customerName", isSubTitle: true, displayName: "", icon: "" },
      { field: 'followUpCompleted', displayName: '', icon: '', isStatus: true },
      { field: 'userName', displayName: 'Created by', icon: '' },
      { field: 'contactName', displayName: 'Contact', icon: '' },
      { field: 'notepadTypeName', displayName: 'Type', icon: '' },
      { field: 'noteDateTime', displayName: 'Note date', icon: '', isDate: true }];

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.loadGridonPageLoad();
    });
  }

  getGridModel(notepadList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'subject',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: notepadList,
      columns: [
        // { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: false },
        // { field: 'customerName', title: 'CUSTOMER NAME', width: 30, hidden: false },
        { field: 'customerCode', title: 'CUSTOMER CODE', width: 100, hidden: !this.customerService.isNotepadDashboard },
        { field: 'customerName', title: 'CUSTOMER NAME', width: 150, hidden: !this.customerService.isNotepadDashboard },
        // { title: 'CUSTOMER', width: 30, hidden: !this.customerService.isNotepadDashboard, cellTemplate: this.customerTemplate },
        { field: 'subject', title: 'SUBJECT', width: 150, hidden: false },
        { field: 'dateTimeCreated', title: 'CREATED', width: 100, hidden: false, cellTemplate: this.createdDateTemplate },
        { field: 'userName', title: 'CREATED BY', width: 100, hidden: false },
        { field: 'contactName', title: 'CONTACT', width: 80, hidden: false },
        { field: 'notepadTypeName', title: 'TYPE', width: 150, hidden: false },
        { field: 'noteDateTime', title: 'NOTE DATE', width: 100, hidden: false, cellTemplate: this.dateTemplate },
        { field: 'followUpCompleted', title: 'STATUS', width: 100, hidden: false, cellTemplate: this.statusTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToDetailsView(eventArg.event.dataItem);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToDetailsView(args.dataItem);
      //   }
      // },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, notepadList, false);
        return observerResult;
      }
    };
    return model;
  }


  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, notepadList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      let length: number = this.notePadCollection.length ? this.notePadCollection.length : 0;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.notePadCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        // this.mobileData = showoff;
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        this.customerNotepadItemsRequest = new GetCustomerNotepadItemsRequest();
        this.customerNotepadItemsRequest.currentUser = this.webTrackUser;
        this.customerNotepadItemsRequest.currentUser.customer.customerId = this.customerId;
        // console.log(this.customerNotepadItemsRequest.currentUser);
        this.paging = new PagingParameters();
        this.paging.index = state.skip;
        this.paging.count = this.pageSize;
        this.customerNotepadItemsRequest.pagingParameters = this.paging;


        this.sort = new SortParameters();
        if (this.customerService.isNotepadDashboard) {
          this.sort.sortColumn = this.sortService.dashboardNotepadSortValue; // "DateTimeCreated";
          this.sort.direction = this.sortService.dashboardNotepadDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        } else {
          this.sort.sortColumn = this.sortService.customerNotepadSortValue; // "DateTimeCreated";
          this.sort.direction = this.sortService.customerNotepadDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        }
        this.customerNotepadItemsRequest.sortParameters = this.sort;

        // filter params

        const seartype = this.GetNoteTypeCriteriaValue();
        this.customerNotepadItemsRequest.searchType = seartype ? seartype : 'AllNotes';
        this.customerNotepadItemsRequest.searchContact = 'AllContacts';
        if (this.customerService.isNotepadDashboard) {
          this.customerNotepadItemsRequest.searchMonths = this.filterService.selectedDashboardDateOptionId ? this.filterService.selectedDashboardDateOptionId : 'AllDates';
          this.customerNotepadItemsRequest.searchValue = this.searchString == undefined ? this.filterService.notepadDashboardSubject : this.searchString;
          this.customerNotepadItemsRequest.customerSearchText = this.filterService.notepadDashboardCustomer ? this.filterService.notepadDashboardCustomer : '';
          this.filterService.notepadDashboardSubject = this.searchString == undefined ? this.filterService.notepadDashboardSubject : this.searchString;
        } else {
          this.customerNotepadItemsRequest.searchMonths = this.filterService.selectedDateOptionId ? this.filterService.selectedDateOptionId : 'AllDates';
          this.customerNotepadItemsRequest.searchValue = this.searchString == undefined ? this.filterService.notepadSubject : this.searchString;
          this.filterService.notepadSubject = this.searchString == undefined ? this.filterService.notepadSubject : this.searchString;
        }

        this.customerNotepadItemsRequest.consumer = GetCustomerNotepadItemsRequestConsumer.BisTrackCloud;

        this.client.getCustomerNotepadItems(this.customerNotepadItemsRequest).subscribe(notepadRes => {
          notepadList = notepadRes.lines;
          if (notepadList != null && notepadList != undefined && notepadList.length > 0) {
            this.totalPages = notepadRes.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (notepadList.length < state.take) {
              this.lastRecords = notepadList;
            } else {
              this.notePadCollection = [...this.notePadCollection, ...notepadList];
            }
            if (!isMobile) {
              this.mobileData = this.notePadCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.notePadCollection.length;
            const result: IEPGridDataResult = {
              data: notepadList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }


  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        let notepadList;
        this.getGridModelData(epGrid, state, notepadList, true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  updateGridData() {
    this.notePadCollection.length = 0;
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.notePadCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  navigateToDetailsView(args) {
    // console.log(args);
    // let navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     "id": this.customerId,
    //     "notepadId": args.customerNotepadID
    //   },
    //   skipLocationChange: true
    // };
    // this.router.navigate(['/home/notepad/addnotepad'], navigationExtras);
    this.router.navigate(['/home/notepad/addnotepad', args.customerID, args.customerNotepadID]);
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }

  // card model

  getList(model) {
    const data = [];
    if (model) {
      const list = Object.keys(model);
      if (this.card) {
        this.card.filter(i => {
          list.filter(k => {
            if (k == i.field) {
              data.push({ key: i.displayName, value: model[i.field], icon: i.icon, isDate: i.isDate, isStatus: i.isStatus, isTitle: i.isTitle, isSubTitle: i.isSubTitle });
            }
          });
        });
      }
    }
    return data;
  }

  private GetNoteTypeCriteriaValue(): string {
    const noteTypeFilter = this.customerService.isNotepadDashboard ? this.filterService.selectedDashboardNotepadType : this.filterService.selectedNotepadType;
    let result: string;
    if (noteTypeFilter) {
      if (noteTypeFilter.systemDefined) {
        if (noteTypeFilter.name == NotepadTypeNames.All) {
          result = 'AllNotes';
        } else if (noteTypeFilter.name == NotepadTypeNames.FollowUp) {
          result = 'FollowUp';
        } else if (noteTypeFilter.name == NotepadTypeNames.System) {
          result = 'SystemNotes';
        } else if (noteTypeFilter.name == NotepadTypeNames.CreditControl) {
          // 119324 QC82
          result = 'CreditControl';
        } else if (noteTypeFilter.name == NotepadTypeNames.Appointment) {
          result = 'Appointments';
        } else if (noteTypeFilter.name == NotepadTypeNames.Event) {
          result = 'Events';
        } else if (noteTypeFilter.name == NotepadTypeNames.CampaignNotes) {
          result = noteTypeFilter.notepadTypeID.toString();
        } else if (noteTypeFilter.applyTo == NotepadTypeApplyTo.Customer && noteTypeFilter.notepadTypeID > 0) {
          // Unfortunately, that test is as specific as we can get in identifying the "Outlook message" NotepadType.
          //  The code that looks for it elsewhere uses the same test: it's in the NotepadType table,
          //  its ApplyTo is Customers, and its SystemDefined value is 1.  I've added a comment in
          //  CRMDataGateway.GetCustomerNotepadItems() about how weak this association is.
          result = 'Outlook';
        } else {
        }
      } else {
        result = noteTypeFilter.notepadTypeID.toString();
      }
    }
    return result;
  }

  loadGridonPageLoad() {
    if (this.customerId && this.customerId != -1) {
      this.gridModel = this.getGridModel([]);
    } else if (
      this.filterService.notepadDashboardSubject != null || this.filterService.notepadDashboardCustomer != '' ||
      (this.filterService.selectedDashboardNotepadType && this.filterService.selectedDashboardNotepadType.name != NotepadTypeNames.All) ||
      this.filterService.selectedDashboardDateOptionId != this.filterService.defaultNotepadDateOption.dateId) {
      this.gridModel = this.getGridModel([]);
    } else { }
  }
}
